export enum ParkingLineColorFilterEnum {
  Verde = 'greenZone',
  Azul = 'blueZone'
}

export enum ParkingTypeFilterEnum {
  Via = 'Via',
  Subterraneo = 'Subterraneo'
}

export enum ParkingZoneFilterEnum {
  DISABLED_ZONE = 'forDisabled',
}

export enum ParkingZoneLoadingFilterEnum {
  ZONA_ONE = 'Zona 1',
  ZONA_TWO = 'Zona 2',
  ZONA_THREE = 'Zona 3'
}

export enum ParkingStatusFilterEnum {
  Disponible = 'free',
  Ocupado = 'occupied',
  Indefinido = 'unknown',
  Nulo = 'null',
}

export enum ParkingGeoTypeEnum {
  ON_STREE_PARKING = 'OnStreetParking',
  OFF_STREE_PARKING = 'OffStreetParking',
  PARKING_SPOT = 'ParkingSpot',
  PARKING_LOADING_ZONE = 'ParkingLoadingZone',
  PARKING_SPOT_LOADING = 'ParkingSpotLoading'
}

export enum NameRunwayFileEnum {
  CARGA_DESCARGA_ZONE = 'Carga_descarga.json'
}
